import React from "react";

const SearchByMove = ({ active, loading, onClick }) => {
  return (
    <div
      className={`searchByMove js-searchByMove ${active ? 'searchByMove--active' : 'searchByMove--inactive'} ${loading && active ? 'searchByMove--loading' : 'searchByMove--static'}`}
      onClick={() => onClick(!active)}
    >
      <div className="searchByMove__checkbox"></div>
      <div className="searchByMove__label">Enable search as I move the map</div>

      <div className="searchByMove__loadingIndicator">
        <div className="searchByMove__loadingIndicatorDots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  );
};

export default SearchByMove;
